import { industry, type Section } from "../../content/industry";
import { Cta, Faq, Features, Logos, Stats, Timeline } from "./Blocks";
import { ContactForm } from "./ContactForm";
import { Carousel } from "./Carousel";
import { Gallery } from "./Gallery";
import { Hero } from "./Hero";
import { Listing } from "./Listing";
import { MenuBoard } from "./MenuBoard";
import {
  Capabilities, Certifications, Industries, Packages, Process, Services, Specialties, Story, Team, Testimonials,
} from "./Sections";
import { SiteFooter, Visit } from "./SiteFooter";
import { SiteHeader } from "./SiteHeader";
import { WhatsAppButton } from "../layout/WhatsAppButton";
import "../../styles/industry.css";

/** Cada tipo de sección tiene su componente; agrega un tipo en content/industry.ts y regístralo aquí. */
function renderSection(section: Section) {
  switch (section.type) {
    case "hero": return <Hero section={section} />;
    case "industries": return <Industries section={section} />;
    case "capabilities": return <Capabilities section={section} />;
    case "process": return <Process section={section} />;
    case "gallery": return <Gallery section={section} />;
    case "carousel": return <Carousel section={section} />;
    case "certifications": return <Certifications section={section} />;
    case "services": return <Services section={section} />;
    case "packages": return <Packages section={section} />;
    case "team": return <Team section={section} />;
    case "testimonials": return <Testimonials section={section} />;
    case "story": return <Story section={section} />;
    case "menu": return <MenuBoard section={section} />;
    case "specialties": return <Specialties section={section} />;
    case "hours": return <Visit section={section} contact={industry.contact} />;
    case "form": return <ContactForm section={section} />;
    case "listing": return <Listing section={section} />;
    case "features": return <Features section={section} />;
    case "stats": return <Stats section={section} />;
    case "faq": return <Faq section={section} />;
    case "timeline": return <Timeline section={section} />;
    case "logos": return <Logos section={section} />;
    case "cta": return <Cta section={section} />;
  }
}

/** Página completa de la plantilla: el arquetipo y el estilo se aplican como clases en el contenedor raíz. */
export function IndustrySite() {
  return (
    <div className={`ix ix--${industry.archetype} ix-style--${industry.style}`}>
      <a className="ix-skip" href="#contenido">Saltar al contenido</a>
      <SiteHeader header={industry.header} nav={industry.nav} />
      <main id="contenido">
        {industry.sections.map(section => <div key={section.id} className="ix-block">{renderSection(section)}</div>)}
      </main>
      <SiteFooter content={industry} />
      {industry.whatsapp?.enabled === false ? null : <WhatsAppButton message={industry.whatsapp?.message} label={industry.whatsapp?.label} />}
    </div>
  );
}
